<script lang="ts">
    import './stylesheets/global.scss';
    import {Utils} from "./util";
    import StepComplete from "./components/StepComplete.svelte";
    import {DoubleBounce, Shadow} from "svelte-loading-spinners";
    import {getContext, onDestroy, onMount, setContext} from "svelte";
    import LeftSidebar from "./components/LeftSidebar.svelte";
    import FormContent from "./components/FormContent.svelte";
    import {createForm, getValue} from 'felte';
    import {get, writable} from 'svelte/store'
    import {myStore, entityStore, uploadProgressStore} from "./stores.js";
    import type {PactRequest} from "./mfi/models/model";
    import type {Community} from "./models/model";
    import UploadModal from "./components/modal/UploadModal.svelte";

    import * as yup from 'yup';

    import {validator} from '@felte/validator-yup';
    import {reporter} from "@felte/reporter-svelte";
    import TestModal from "./components/modal/TestModal.svelte";
    import Modal, {bind} from "svelte-simple-modal";
    import ConfirmModal from "./components/modal/ConfirmModal.svelte";
    import UploadErrorModal from "./components/modal/UploadErrorModal.svelte";


    let observedElement;
    let observedAfterElement;
    const modal = writable(null);
    const uploadModal = writable(null);
    const uploadError = writable(null);
    const testModal = writable(null);

    const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB in bytes


    let uploadProgress = 0;

    let steps = [
        {
            key: 'step1',
            title: 'Informations sur la personne de contact',
            isActive: true,
            valid: null,
            touched: false,
            disabled: false,
            expanded: true
        },
        {
            key: 'step2',
            title: 'Adhésion au pacte communal',
            isActive: false,
            valid: null,
            touched: false,
            disabled: true,
            expanded: false
        },
        {
            key: 'step3',
            title: 'Coordinateur·trice pacte communal',
            isActive: false,
            valid: null,
            touched: false,
            disabled: true,
            expanded: false
        },
        {
            key: 'step4',
            title: 'Subventions',
            isActive: false,
            valid: null,
            touched: false,
            disabled: true,
            expanded: false
        },
        {
            key: 'step5',
            title: 'Coordonnées bancaires',
            isActive: false,
            valid: null,
            touched: false,
            disabled: true,
            expanded: false
        },
        // Add other steps as needed
    ];

    let stickySidebar = false;
    let initState = true;

    onMount(() => {


       //testCloseResult();

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Element has entered the viewport, do something
                    console.log('Element is in the viewport!');
                    //stickySidebar = false;
                } else {
                    // Element has left the viewport, do something else
                    console.log('Element is out of the viewport!');

                    if(initState){
                        initState = false;
                    }else{
                      //  stickySidebar = true;

                    }


                }
            });
        }, {
            root: null, // observing with respect to viewport, can be changed to another element
            rootMargin: '-140px 0px 0px 0px',
            threshold: 0.1 // 10% of the element must be in view to trigger
        });



        //element after form:
        const observerAfter = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Element has entered the viewport, do something
                    console.log('After Element is in the viewport!');
                    if(stickySidebar){
                      //  stickySidebar = false;
                    }

                } else {
                    // Element has left the viewport, do something else
                    console.log('After Element is out of the viewport!');
                    if(!stickySidebar && !initState){
                     //   stickySidebar = true;
                    }

                }
            });
        }, {
            root: null, // observing with respect to viewport, can be changed to another element
            rootMargin: '200px 0px 0px 0px',
            threshold: 0.5 // 10% of the element must be in view to trigger
        });


        if (observedElement) {
            observer.observe(observedElement);
        }

        if (observedAfterElement) {
            observerAfter.observe(observedAfterElement);
        }

        return () => {
            if (observedElement) {
                observer.unobserve(observedElement);
            }
            if (observedAfterElement) {
                observerAfter.unobserve(observedAfterElement);
            }
        };




    });



    let interval: any;
    let files = [];
    // let items: OrderItem[] = [];


    let loading: Promise<any>;

    //TODO not needed
    //let token: any;

    onMount(() => {
       // token = Utils.getCookie('token');
    });

    const showError = (e: { status: string, message?: { errors: { [field: string]: string[] }, message: string } }) => {
      //  console.log(open, e);
        let title = '';
        let message = '';
        if (e?.message?.errors) {
            title = 'Error';
            message = 'One or more fields are invalid or not filled in. Please check your entry and try again.'
            /*
            const errors = Object.keys(e.message.errors)
                .map(field => `${field}: ${e.message.errors[field].join(', ')}`);
            title = e.message.message;
            message = errors.join('\n');
            */
        } else {
            title = e?.status || 'Upload Error!';
            message = 'There was a problem with the server. Please repeat your request.';
        }

        uploadError.set(bind(UploadErrorModal,{title, message}));

    }
    /*
     closeButton: false,
            } as ModalProps), () => {
                onclose = (event) => {
                    console.log("result = ", event);
                }

     */

    const showConfirmation = (d: any) => {
        console.log("data for showConfirmation: ", d);
        modal.set(bind(ConfirmModal,{data:d}));
    }


    function uploadData(x:any){



        const d = $uploadProgressStore.data;

        if(!d)
            return;

        console.log("data from submit dialog:",d);
        const postData = Utils.formValueToFormData(d);

        //reset before upload:
        let progress = 0;
        uploadProgressStore.update($uploadProgressStore => ({
            ...$uploadProgressStore,
            value: progress,
            complete: false
        }));

        uploadModal.set(bind(UploadModal,{}));

        Utils.postPactData('/api/api/mfi/public/pact/request', postData, (currentProgress:any) => {
            progress = currentProgress;

            uploadProgressStore.update($uploadProgressStore => ({
                ...$uploadProgressStore,
                value: progress,
            }));

        }).then(response => {
            console.log('Upload successful', response);
            uploadProgressStore.update($uploadProgressStore => ({
                ...$uploadProgressStore,
                complete: true
            }));

            // Close the modal automatically when upload is complete
            uploadModal.set(null);

            //TODO reset form:
            reset();
            entityStore.update($entityStore => ({
                ...$entityStore,
                steps: steps,
                availableCommunities:[],
            }));

        }).catch(error => {
            console.error('Upload failed', error);
            uploadModal.set(null);
            showError(error);
        });

        /* old way:
        Utils.post("/api/api/mfi/public/pact/request", postData).then(v => {

            console.log("sucessful uploaded, result = ", v);
            //TODO close modal and reset form

        }, e => {
            console.log("error",e);
            //loading = null;
            //showError(e);
            //TODO output errors
            throw e;
        })

            .then(data => console.log(data))
            .catch(error => console.error('Error:', error));
*/
    }

    function modalTest(){

        reset();

        testModal.set(bind(TestModal,{


        }));
    }

    function testCloseResult()
    {
        //reset before upload:
        let progress = 0;
        uploadProgressStore.update($uploadProgressStore => ({
            ...$uploadProgressStore,
            value: progress,
        }));

        //uploadModal.set(null);
        uploadModal.set(bind(UploadModal,{}));

        //fake progress
        interval= setInterval(() => {
            if (progress < 100) {
                progress += 10; // Increment by 10% each second
                uploadProgressStore.update($uploadProgressStore => ({
                    ...$uploadProgressStore,
                    value: progress,
                }));
            } else {

                clearInterval(interval); // Stop the interval when progress reaches 100%
            }

        },500); // 1000 milliseconds = 1 second

    }

    // Clean up the interval when the component is destroyed
    onDestroy(() => {
        clearInterval(interval);
    });

    function clearFiles() {
        files = [];
    }

    function submit() {

        let data: any = {};

        console.log("data for submission:", data);

        /*
        Utils.post("/api/api/paymall-homepage/order", data,token).then(v => {

            console.log("success!", v);

        }, e => {

            console.log("error",e);
            //showError(e);
            //throw e;
        });
*/
        // data.forEach((entry, key) => console.log(key, entry));
        /*
        loading = Utils.post("/api/api/mfi/pact/request", data.detail.data,token).then(v => v, e => {
            console.log("error",e);
            loading = null;
            showError(e);
            throw e;
        });

         */
    }




    const firstPactPersonSchema = yup.object({
        firstname: yup.string().required(),
        lastname: yup.string().required(),
        position: yup.string().required(),
        address: yup.string().required(),
        email: yup.string().email().required(),
        phone: yup.string().required(),

    });

    const otherPactPersonSchema = yup.object({
        firstname: yup.string().nullable().notRequired(), // optional
        lastname: yup.string().nullable().notRequired(),  // optional
        position: yup.string().nullable().notRequired(),  // optional
        email: yup.string().nullable().notRequired(),  // optional
        phone: yup.string().nullable().notRequired(),  // optional
        address: yup.string().nullable().notRequired()  // optional
    });

    /*
    const pactPersonSchema = yup.array().of(
        yup.lazy((item, index) => {
           // console.log("index ?", index);
           // console.log("item ? ", item);
            //TODO index is an object instead of number
           return (index === 0 ? firstPactPersonSchema : otherPactPersonSchema)
        })
    );

     */

    /* not working this way:
    const pactPersonSchema = yup.object().shape({
        firstname: yup.string().when([], (schema, { parent, path }) =>
            path.startsWith("0.") ? schema.required("First name is required for the first person") : schema
        ),
        lastname: yup.string().when([], (schema, { parent, path }) =>
            path.startsWith("0.") ? schema.required("Last name is required for the first person") : schema
        ),

    });
*/
    /* STEP VALIDATION SCHEMAS */

    //contact person data
    const step1Schema = yup.object({

        firstPactPerson: firstPactPersonSchema, //yup.array().of(pactPersonSchema),
        secondPactPerson: otherPactPersonSchema,
    });
    //bank data
    const step5Schema = yup.object({
        // Validation for step 2 fields
        tmp_pactIsSignedBySyndicate: yup.boolean(),
        bankAccounts: yup.array().min(1),
    });
    // Repeat for other steps...

    const coordinatorSchema = yup.object().shape({
        firstname: yup.string().required(),
        lastname: yup.string().required(),
        //description: yup.string().required(),
        files: yup.mixed()
            .test('fileExists', 'You must upload at least one file', (value:any) => {
                // Check that there's at least one file
                return value && value.length > 0;
            }),
        type: yup.string().required(),
        communities: yup.array().when('pactIsSignedBySyndicate', {
            is: true, // When hasCoordinators is true
            then: (schema) => schema.nullable().notRequired(),
            otherwise: (schema) => schema.min(1)//.max($entityStore.availableCommunities.length)// No additional validation when hasCoordinators is false
        }),
    });


    const schema = yup.object({
        email: yup.string().email().nullable().notRequired(),
        step1: yup.object({
            firstPactPerson: yup.object({
                firstname: yup.string().required(),
                lastname: yup.string().required(),
                position: yup.string().required(),
                address: yup.string().required(),
                email: yup.string().email().required(),
                phone: yup.string().required(),
            }),
            secondPactPerson: yup.object({
                firstname: yup.string().nullable().notRequired(),
                lastname: yup.string().nullable().notRequired(),
                position: yup.string().nullable().notRequired(),
                email: yup.string().nullable().notRequired(),
                phone: yup.string().nullable().notRequired(),
                address: yup.string().nullable().notRequired()
            })
        }),

        step2: yup.object({

            communities: yup.array().min(1),
            pactIsSignedBySyndicate: yup.boolean(),
            syndicateName: yup.string().when('pactIsSignedBySyndicate', {
                is: false,
                then: (schema) => schema.nullable().notRequired(), // Make syndicateName nullable
                otherwise: (schema) => schema.required('Syndicate name is required'), // Keep as required string if hasIsSignedBySyndicate is true
            }),
            applicationChairmanFiles: yup.mixed()
                .test(
                    'fileSize',
                    'FileSizeToBig',
                    (value:any) => {
                        if (!value || !value.length) {
                            // If no files are uploaded, we don't fail this test
                            // because we're only checking for file size here.
                            // The existence of files should be checked in another test.
                            return true;
                        }
                        // Check that every file is less than or equal to MAX_FILE_SIZE
                        return Array.from(value).every(file => file?.size <= MAX_FILE_SIZE);
                    }
                )
                .test('fileExists', 'You must upload at least one file', (value:any) => {
                    // Check that there's at least one file
                    return value && value.length > 0;
                }),
            applicationPersonFiles: yup.mixed()
                .test(
                    'fileSize',
                    'FileSizeToBig',
                    (value:any) => {
                        if (!value || !value.length) {
                            // If no files are uploaded, we don't fail this test
                            // because we're only checking for file size here.
                            // The existence of files should be checked in another test.
                            return true;
                        }
                        // Check that every file is less than or equal to MAX_FILE_SIZE
                        return Array.from(value).every(file => file?.size <= MAX_FILE_SIZE);
                    }
                )
                .test('fileExists', 'You must upload at least one file', (value:any) => {
                    // Check that there's at least one file
                    return value && value.length > 0;
                })

        }),

        step3: yup.object({
            // Validation for step 2 fields
            hasCoordinators: yup.boolean(),
            wantFutureCoordinators: yup.string().required(),
            hasPactCoordinators: yup.boolean(), //needed?

            pactCoordinators: yup.array()
                .when('hasCoordinators', {
                    is: true, // When isCoordinatorsRequired is true
                    then: (schema) => schema.of(coordinatorSchema).min(1, 'At least one coordinator is required'),
                    otherwise: (schema) => schema.notRequired(),
                }),
            futureCoordinatorFiles: yup.mixed()
                .when('wantFutureCoordinators', {
                    is: 'YES', // When isFileRequired is true
                    then: (schema) => schema.required('A file is required')
                        .test(
                            'fileSize',
                            'FileSizeToBig',
                            (value:any) => {
                                if (!value || !value.length) {
                                    return true;
                                }
                                return Array.from(value).every(file => file?.size <= MAX_FILE_SIZE);
                            }
                        )
                        .test('fileExists', 'You must upload at least one file', (value:any) => {
                            return value && value.length > 0;
                        }),

                    otherwise: (schema) => schema.notRequired() // No file required if isFileRequired is false
                }),

            externalCoordinatorDescription:yup.string().notRequired()

        }),
        step4: yup.object({
            wantApplyCosts: yup.string().required(),
            wantApplyCommunalPact: yup.boolean(),
        }),
        step5: yup.object({
            // Validation for step 2 fields
            bankAccounts: yup.array()
                .of(
                    yup.lazy((value, options) => {

                        const rootData = options.from?.[options.from.length - 1]?.value;
                        const isSyndicate = rootData?.step2?.pactIsSignedBySyndicate; // Zugriff auf step2




                        return yup.object({
                        iban: yup.string().required('IBAN is required').min(5).max(30), // Validate IBAN
                        community_id:  isSyndicate
                            ? yup.number().nullable().notRequired()
                            : yup.number().required('Community is required'),


                            // No additional validation when hasCoordinators is false


                       files: yup.mixed()
                           .test(
                               'fileSize',
                               'FileSizeToBig',
                               (value:any) => {
                                   if (!value || !value.length) {
                                       return true;
                                   }
                                   return Array.from(value).every(file => file?.size <= MAX_FILE_SIZE);
                               }
                           )
                            .test('fileExists', 'You must upload at least one file', (value:any) => {
                                return value && value.length > 0;
                            })
                    });
                        })
                )//.min(1) //TODO: when() is not working here because we can not access pactIsSignedSyndicate from Step2 inside Step5

                .when(['../step2.pactIsSignedBySyndicate'], (pactIsSignedBySyndicate, schema) => {
                    return pactIsSignedBySyndicate
                        ? schema.min(1, 'At least one bank is required')
                        : schema.min($entityStore.availableCommunities.length, `minimum ${$entityStore.availableCommunities.length} needed`);
                }),



        })

    });

    const {
        form, data, reset, setData, setFields, addField, unsetField, resetField, errors, warnings, isValid, touched,
        interacted
    } = createForm({

        initialValues: {
            email: null,

            step1: {
                firstPactPerson: {
                    firstname: null, lastname: null, position: null, address: null, email: null, phone: null
                },
                secondPactPerson: {
                    firstname: null, lastname: null, position: null, address: null, email: null, phone: null
                },
            },
            step2: {

                syndicateName: null,
                pactIsSignedBySyndicate: false,
                applicationChairmanFiles: null,
                applicationPersonFiles: null,
                communities: [],
            },
            step3: {
                hasCoordinators: true,
                hasPactCoordinators: true,
                wantFutureCoordinators: null,
                pactCoordinators: [{
                    firstname: null,
                    lastname: null,
                    files: [],
                    type: null,
                    communities:[]
                }],
                coordinators: [{firstname: null, lastname: null, description: null,files:[],type:null,communities:[]}], //TODO check if still needed
               futureCoordinatorFiles:[],
                externalCoordinatorDescription:null
            },
            step4: {
                wantApplyCosts: null,
                wantApplyCommunalPact: false
            },
            step5: {
                bankAccounts: [{iban: null, files: [], community_id: null}],
            }

        },

        extend: [reporter, validator({schema})],

        //validate: validator({ schema: schema }),


        validate: async (values) => {

            //console.log("validate bla", values);

            try {
                await schema.validate(values, {abortEarly: false});
            } catch (err) {
                console.log("error::::", err);
                const errors = err.inner.reduce((res, value) => ({
                    [value.path]: value.message,
                    ...res,
                }), {});
                return errors;
            }
        },


        //validate: validator({ schema: schema}),

        onSubmit: (values) => {

            console.log("onSubmit called. Form data = ", values);

            //prepare data
            const uploadData = prepareData(values);

            showConfirmation(uploadData);


            /* alternative:
                                   const url = 'https://dashboard.zesummeliewen.lu/api/api/mfi/public/pact/request';
                                               //const postData = Utils.formValueToFormData(values);

                       fetch(url, {
                           method: 'POST',
                           headers: {
                               'Content-Type': 'multipart/form-data',
                               'Accept': 'application/json'
                               // Include other headers as required
                           },
                           body: postData //SON.stringify(data),
                       })
                           .then(response => {
                               if (response.redirected) {
                                   console.log("result = ", response);
                                   // Handle redirection if necessary
                               }
                               return response.json();
                           })
                           .then(data => console.log(data))
                           .catch(error => console.error('Error:', error));
           */

        },
    })


    function prepareData(rawData:any) {

        console.log("rawData = ", rawData);

        let values:PactRequest = {};

        values.pactPerson =  [rawData.step1.firstPactPerson];
        //const flattenedArray = Object.values(steps).flat();

        if (rawData.step1.secondPactPerson) {
            values.pactPerson.push(rawData.step1.secondPactPerson);
        }

        //step2:
        values.communities = [];
        rawData.step2.communities.forEach(c => {
           values.communities.push({community_id:c})
        });
        values.pactIsSignedBySyndicate = rawData.step2.pactIsSignedBySyndicate;
        if (values.pactIsSignedBySyndicate) {
            values.syndicateName = rawData.step2.syndicateName;

        }
        values.applicationFileChairman = rawData.step2.applicationChairmanFiles;
        values.applicationFilePerson = rawData.step2.applicationPersonFiles;

        //step3:
        values.hasCoordinators = rawData.step3.hasCoordinators;
        values.wantFutureCoordinators = rawData.step3.wantFutureCoordinators;


        if(values.wantFutureCoordinators == 'YES'){

            values.futureCoordinatorFiles = rawData.step3.futureCoordinatorFiles;// ? rawData.step3.futureCoordinatorFiles : [];
        }

        values.externalCoordinatorDescription = rawData.step3.externalCoordinatorDescription;
        if (values.hasCoordinators) {
            values.pactCoordinators = JSON.parse(JSON.stringify(rawData.step3.pactCoordinators));
        }else{

        }
        if(values.pactIsSignedBySyndicate && values.pactCoordinators){
            values.pactCoordinators.forEach((c:any) =>{
                c.syndicateName = values.syndicateName;
            })
        }

        if(values.pactCoordinators){
            values.pactCoordinators.forEach(c =>{

                c.files.forEach((value,index) => {
                    c['file'+(index+1)] = value;
                })
                delete c.files;

            })
        }


        //step4:
        values.wantApplyCosts = rawData.step4.wantApplyCosts;
        values.wantApplyCommunalPact = rawData.step4.wantApplyCommunalPact;

        //step5:
        if(values.pactIsSignedBySyndicate){
            let bank = rawData.step5.bankAccounts[0];
            bank.syndicateName = rawData.step2.syndicateName;

            bank.files.forEach((value,index) => {
                bank['file'+(index+1)] = value;
            })
            delete bank.files;
            delete bank.community_id;

            values.communities.push(bank);
        }else{
            rawData.step5.bankAccounts.forEach(bank => {
                //search for community with same id:

                let com = values.communities.find(c => c.community_id == bank.community_id);
                let comIndex = values.communities.findIndex(c => c.community_id == bank.community_id);

                if(com){
                    com = bank;

                    com.files.forEach((value,index) => {
                        com['file'+(index+1)] = value;
                        delete com.files;

                    })


                    values.communities[comIndex] = com;
                }
            });
        }
        // remove null values
        for (let key of Object.keys(values)) {
            if (values[key] == null)
                delete values[key];
        }

        if(values.pactPerson[1].email == null || values.pactPerson[1].email == ""){
            console.log("pactPerson 2 email = null")
            for (let key of Object.keys(values.pactPerson[1])) {
                if (values.pactPerson[1][key] == null || values.pactPerson[1][key] == "")
                    delete values.pactPerson[1][key];
            }

        }


       // let d = Utils.formValueToFormData(values);

        console.log("final data after null check:",values);
        return values;
    }


    let communities: Community[] = [];

    //fetch community data;
    let url = `/api/api/mfi/public/community?isPaginated=0&lang=${lang}`;//filter%5BhasPact%5D=0&

    Utils.get<Community[]>(url).then(async r => {
        const communities = r.map(c => {
            return {
                value: c.id,
                label: Utils.chooseTranslation(c.name)
            }
        })
        console.log("community result = ", communities);
        entityStore.update($entityStore => ({
            ...$entityStore,
            allCommunities: communities,
        }));
    });

    $entityStore = {steps: steps, allCommunities: communities, availableCommunities: communities}; //todo set available based on selection!


    $:{
        $myStore = {
            data: $data,
            setFields: setFields, setData: setData, addField: addField, unsetField: unsetField, resetField: resetField,
            errors: $errors, warnings: $warnings, isValid: $isValid, interacted: $interacted
        };
    }


    /*
    async function updateValidationValues(data) {
         await updateStepValidation(data);
    }


    const updateValidation = Utils.debounce(updateValidationValues($data),1000);


    $:{
        updateValidation();

    }
*/

    $:{
        updateStepsValidation($data)

    }

    /*
    async  function updateSingleStepValidation(stepKey) {

        let formData = $data;

        const step = await validateStep(formData,stepKey);

           const updatedStep =  {
                    ...step,
                    valid: step.valid,
                    touched: checkTouched(step),
                    isActive: checkActive(step)
                };



        let steps = $entityStore.steps;
        steps[stepKey] = updatedStep;


        entityStore.update($entityStore => ({
            ...$entityStore,
            steps,
        }));
        console.log("steps after: ",$entityStore.steps);

    }
*/

    async function updateStepsValidation(formData) {

        const validationResults = await validateEachStep(formData);
        console.log("updated dataZZ:::", validationResults);
        const tmpSteps = $entityStore.steps.map(step => {
            // If there's a validation result for this step, update the 'valid' property
            if (validationResults[step.key]) {
                return {
                    ...step,
                    valid: validationResults[step.key].valid,
                    //touched: checkTouched(step.key),
                    //isActive: checkActive(step.key)
                };
            }
            // If there's no validation result (e.g., the step wasn't validated), leave the step unchanged
            return step;
        });

        entityStore.update($entityStore => ({
            ...$entityStore,
            steps: tmpSteps,
        }));
        console.log("steps after: ", $entityStore.steps);
    }

    setContext('validateStep', updateStepsValidation);


    async function validateEachStep(formData) {
        const stepKeys = Object.keys(schema.fields); // Get all step keys
        // console.log("step keys = ", stepKeys);
        const validationResults = {};

        for (const stepKey of stepKeys) {
            try {
                // Validate each step individually
                await schema.validateAt(stepKey, formData);
                validationResults[stepKey] = {valid: true};
            } catch (error) {
                // Collect errors for steps that are not valid
                validationResults[stepKey] = {valid: false, errors: error.errors};
            }
        }

        return validationResults;
    }

    //single step validation:
    async function validateStep(formData, step) {
        try {
            // Assuming `step` is something like "step1", "step2", etc.
            await schema.validateAt(step, formData);
            return {valid: true};
        } catch (error) {
            return {valid: false, errors: error.errors};
        }
    }

    function checkActive(stepKey) {

        //ignore if nothing was clicked before:
        if ($interacted != null) {
            return $interacted?.includes(stepKey);
        } else {
            console.log("nothing happen until now...");
            console.log("entityStore.steps = ", $entityStore.steps);
            console.log("stepKey = ", stepKey);
            const index = $entityStore.steps.findIndex(s => s.key == stepKey);
            if (index) {
                console.log("lala step = ", $entityStore.steps[index]);
                return $entityStore.steps[index].isActive;
            } else {
                return false;
            }
        }


    }


    function checkTouched(stepKey) {
        console.log("step key = ", stepKey);
        console.log("touch ALL = ", $touched);
        const step = $touched[stepKey];
        const flattenedArray = Utils.flattenObject(step);
        console.log("check touched for step = ", step);
        console.log("flatten = ", flattenedArray);

        for (const field of flattenedArray) {

            if (field.value == true)
                return true;
        }
        return false;

    }

    function appendToBody(node) {
        document.body.appendChild(node);

        return {
            destroy() {
                document.body.removeChild(node);
            }
        };
    }
    const modalStyles = {
        padding:0,
    }

</script>

<div use:appendToBody>
    <Modal show={$modal} classWindow="custom-modal" classBg="custom-modal-bg" closeButton={false} styleContent={modalStyles}  on:close={uploadData}></Modal>
    <Modal show={$testModal} classWindow="custom-modal" classBg="custom-modal-bg" closeButton={false} styleContent={modalStyles} on:close={testCloseResult}></Modal>
    <Modal show={$uploadModal} classWindow="custom-modal" classBg="custom-modal-bg" closeButton={false} styleContent={modalStyles} closeOnOuterClick={false} closeOnEsc={false} on:close={() => uploadModal.set(null)}></Modal>
    <Modal show={$uploadError} classWindow="custom-modal" classBg="custom-modal-bg" closeButton={false} styleContent={modalStyles} closeOnOuterClick={true} closeOnEsc={true}></Modal>

</div>

<!--
{#if loading}
    {#await loading}
        <div class="spinner-wrapper">
            <DoubleBounce size="80" color="#BB29BB" unit="px" duration="1s"></DoubleBounce>
        </div>
    {:then response}
        <StepComplete></StepComplete>
    {/await}
{:else}
-->

    <!--<button on:click={modalTest}>modal test</button>-->

    <!--viewport check-->
    <div bind:this={observedElement} style="width: 100%;height: 50px;"></div>

    <form use:form id="mfi-request-form-wrapper"  >

        <LeftSidebar sticky={stickySidebar}></LeftSidebar>

        <FormContent stickySidebar={stickySidebar} {form}></FormContent><!-- on:submitBtnClicked={ () => submit()}-->
        <!--on:submitBtnClicked={ (data) => submit(data)}-->

    </form>
<div  bind:this={observedAfterElement}>
</div>
<!--
    {#if stickySidebar}
        <div class="sticky-bottom-devider"></div>
    {/if}
-->

<!--
{/if}
-->

<style lang="scss">
    .spinner-wrapper {
        display: flex;
        justify-content: center;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        align-items: center;
        z-index: 10;
        background-color: rgb(255 255 255 / 0.3);
        backdrop-filter: blur(10px);
    }


    .sticky-bottom-devider{
        height: 295px; //height of website footer, to avoid overflow hidden for static (sticky) sidebar
    }
</style>
